import React from 'react';
import * as IptC from './_ccbIptC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as LblC from './_cccLblC';
import * as BtnsC from './_ccmBtnsC';
import * as HdrC from './_ccmHdrC';
import * as RootC from './_ccmRootC';
import * as SchC from './_ccmSchC';
import * as TblC from './_ccmTblC';
import * as _cm from './_cm';
import { a } from './_cmABT';
import * as _cmFTH from './_cmFTH';
import * as _cr from './_cr';
import * as _gv from './_gv';
import * as _ls from './_csLcl';
import { useNgnz } from './_csNgn';
import * as _hm from './_hm';
import * as _ht from './_ht';

import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';

const $cz = {
  tgt: '事業者',
};

let $i19z = {} as _ht.dz;

let $i19rs = [] as _ht.ls;

let $i19r_fst = -1;

const $schz = {
  word: '',
};

const $schAsync = async (
  frcUdt: () => void
) => {
  $i19rs = await _cmFTH.loadLsAsync2({
    tgt: 'i19r.loadi19zLsAsync',
    ... $schz,
  });
  if (frcUdt) frcUdt();
};

export const R = (pz: {
  sRz: _ht.dz,
}) => {

  const _sPz = _ls.usePz({
    steps: [1],
    phs: 'd',
  });

  return (
    _cr.c(icvBaseM10Rz.N, {},
      _cr.c(RootC.N, {
        sPz: _sPz,
        dsnz: {
          pageW: 80,
        },
        hdrClds: [
          _cr.c(H, {
            sPz: _sPz,
          })
        ],
        schStlz: a(`dw/w3`),
        schClds: [
          _cr.c(S, {
            sPz: _sPz,
          })
        ],
        btnClds: [
          _cr.c(B, {
            sPz: _sPz,
          })
        ],
        topClds: [
        ],
        cttClds: [
          _cr.c(C, {
            sPz: _sPz,
          })
        ],
      })
    )
  );

};

export const H = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(HdrC.N, {
      sPz: pz.sPz,
      abtz: icv.abtz.mainHdrz,
      cz: {
        tgt: $cz.tgt
      }
    })
  );
};

export const S = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(SchC.N, {
      sPz: pz.sPz,
      abtz: {
        btnSchz: icv.abtz.btnSchz,
        gridSchz: icv.abtz.gridSchz,
      },
      schClds: [
        _cr.c(IptC.N, {
          cz: {
            bEdit: true,
            iptType: 't',
            vle: $schz.word,
            onChg: (_s: _ht.s) => {
              $schz.word = _s;
            },
          },
          iptPtyz: a(`ipt/${$cz.tgt}ID、${$cz.tgt}名 ipc/lt3`),
        }),
      ],
      onSch: () => $schAsync(pz.sPz.udtAll),
    })
  );
};

export const T = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();
  const _gUserz = _gv.useUserz();

  React.useEffect(() => {
    if (
      _gUserz.crt._20rz._key > 0 && 
      pz.sPz.crt.steps[0] == 1
    ) {
      _hm.ectSrlAsync([
        async () => {
          await $schAsync(_udtThis);
        },
      ])
    }
  }, [
    _gUserz.crt._20rz._key,
    pz.sPz.crt.steps[0]
  ])

  const _hdrCs = [
    {
      cellCs: [
        {
          boxStlz: a(`dw/icn`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `ID`,
            }),
          ]
        },
        {
          boxStlz: a(`f/1`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `${$cz.tgt}名`,
            }),
          ]
        },
        {
          boxStlz: a(`dw/btn`),
          boxClds: [

          ]
        }
      ]
    }
  ];

  const _bdyCs = $i19rs?.map((_i19rz: _ht.dz) => {
    return (
      {
        cellCs: [
          {
            boxStlz: a(`dw/icn`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${_i19rz._icn}`,
              }),
            ]
          },
          {
            boxStlz: a(`f/1 fd/rsc`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${_i19rz._pfx}`,
              }),
            ]
          },
          {
            boxStlz: a(`dw/btn`),
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnDtlz,
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      $i19r_fst = _i19rz._fst;
                      pz.sPz.set({
                        steps: [1],
                        phs: 'd',
                      })
                    }
                  }            
                },
              }),

            ]
          }
        ]
      }
    );
  });

  return (
    _cr.c(TblC.N, {
      abtz: icv.abtz.tblLinez,
      hdrCz: {
        abtz: icv.abtz.gridTblHdrz,
        lineCs: _hdrCs,
      },
      bdyCz: {
        abtz: icv.abtz.gridTblBdyz,
        lineCs: _bdyCs
      }
    })

  );

};

export const C = (pz: {
  sPz: _ht.dz,
}) => {

  const _gUserz = _gv.useUserz();
  const _udtThis = _ls.udtThis();

  React.useEffect(() => {
    if (_gUserz.crt._20rz._key > 0) {
      _cmFTH.loadDzAsync2({
        tgt: 'i19r.loadI19zDzAsync',
        _20r_key: _gUserz.crt._20rz._key,
      })
      .then((_i19z: _ht.dz) => {
        if (_hm.f(_i19z.i19rz)) {
          $i19z = _i19z;
        }
        else {
          $i19z = {
            i19rz: {
              i19r_20r1k: _gUserz.crt._20rz._key,
            },
          };
        }
        _udtThis();
      });
    }
  }, [
    _gUserz.crt._20rz._key,
    pz.sPz.crt.steps[0],
    pz.sPz.crt.phs
  ])

  return (
    _cr.c(GridC.N, {
      abtz: icv.abtz.gridCttz,
      lineCs: [
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `${$cz.tgt}名：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?._pfx,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              _pfx: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `郵便番号：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?.i19ra1100s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              i19ra1100s: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `所在地：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?.i19ra1200s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              i19ra1200s: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `電話番号：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?.i19ra2100s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              i19ra2100s: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `FAX番号：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?.i19ra2200s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              i19ra2200s: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `振込先１：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?.i19ra3100s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              i19ra3100s: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `振込先２：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?.i19ra3120s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              i19ra3120s: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `請求書記載項目１：`,
                    boxStlz: a(`dw/20`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?.i19ra4210s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              i19ra4210s: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `請求書記載項目２：`,
                    boxStlz: a(`dw/20`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i19z.i19rz?.i19ra4220s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i19z.i19rz, {
                              i19ra4220s: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
      ]
    })

  );

};

const $upsAsync = async (sCfmz: _ht.dz) => {
  await _cmFTH.ugdDzAsync2({
    tgt: 'i19r.ugdI19zDzAsync',
    i19z: $i19z,
  })
  .then((_i19z: _ht.dz) => {
    $i19r_fst = _i19z.i19rz._fst;
  });
};

export const B = (pz: {
  sPz: _ht.dz,
}) => {

  const _sNgnz = useNgnz();

  return (
    _cr.c(BtnsC.N, {
      sPz: pz.sPz,
      abtz: {
        gridBtnz: icv.abtz.gridBtnz,
        btnNextz: icv.abtz.btnNextz,
        btnBackz: icv.abtz.btnBackz,
      },
      cz: {
        tgt: $cz.tgt,
        onBackCtt: () => {
          _sNgnz.setPageName('icvHomeM20Rz');
        },
        onCrtAsync: $upsAsync,
        onUdtAsync: $upsAsync,
      }
    })  
  );

};
